/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */


import authConfig from '../../auth_config.json';

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

// Store functionality
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import modules from './modules';

import invites from '@/modules/invites/invites';
import library from '@/modules/library/library';
import slack from '@/modules/slack/slack';
import version from '@/modules/version/version';

Vue.use(Vuex);

// devtools true set before the new Vuex.Store allows the vue extension to inspect the state in Chrome.
Vue.config.devtools = authConfig.devtools;

modules[invites.moduleName] = invites;
modules[library.moduleName] = library;
modules[slack.moduleName] = slack;
modules[version.moduleName] = version;

const store = new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  modules,
});

export default store;
